
    <ng-content select="nb-accordion-item"></ng-content>
  